<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted, watchEffect } from "vue"
import { useQuasar } from "quasar"
import { type RouteRecordNameGeneric, useRouter } from "vue-router"
import { useAuthStore } from "./stores/auth"
import { useListStore } from "@/stores/list"
import { useListItemStore } from "@/stores/list-item"
import { useItemStore } from "@/stores/item"
import { useDepartmentStore } from "@/stores/department"
import { useOptionStore } from "@/stores/option"
import { useHistoryStore } from "@/stores/history"
import { useReminderStore } from "@/stores/reminder"
import { useStoreStore } from "@/stores/store"

const { loadingBar } = useQuasar()
const router = useRouter()
const authStore = useAuthStore()
const listStore = useListStore()
const listItemStore = useListItemStore()
const reminderStore = useReminderStore()
const itemStore = useItemStore()
const departmentStore = useDepartmentStore()
const storeStore = useStoreStore()
const optionStore = useOptionStore()
const historyStore = useHistoryStore()

const openPages: RouteRecordNameGeneric[] = ["login", "invite"]

router.beforeEach(async to => {
  await authStore.refresh()

  if (!authStore.loggedIn && !openPages.includes(to.name)) {
    localStorage.setItem("redirect", to.fullPath)
    return { name: "login" }
  }

  if (authStore.loggedIn && to.name == "login") {
    return { name: "home" }
  }
})

let wakeLock = null as WakeLockSentinel | null

const requestWakeLock = async () => {
  if (wakeLock && !wakeLock.released) return

  try {
    wakeLock = await navigator.wakeLock.request("screen")
  } catch {}
}

onMounted(async () => {
  addEventListener("visibilitychange", async () => {
    if (document.visibilityState == "visible") {
      await requestWakeLock()
    }
  })
  requestWakeLock()
})

watchEffect(async () => {
  if (authStore.loggedIn) {
    loadingBar.start()
    await listStore.refresh()
    loadingBar.increment(10)
    await listItemStore.refresh()
    loadingBar.increment(10)
    await reminderStore.refresh()
    loadingBar.increment(10)
    await itemStore.refresh()
    loadingBar.increment(10)
    await departmentStore.refresh()
    loadingBar.increment(10)
    await storeStore.refresh()
    loadingBar.increment(10)
    await optionStore.refresh()
    loadingBar.increment(10)
    await historyStore.refresh()
    loadingBar.stop()
  }
})
</script>
